import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { DnRevenue } from '../_models';
import { ArrayResponse, BaseResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DnRevenueService {

  constructor(private http: HttpClient) { }

  getAll(filter: any, realtimeFlag: boolean): Observable<ArrayResponse>  { //listing
    return this.http.post(`${environment.apiUrl}/report/dn-revenue/graph?realtime=${realtimeFlag}`, filter)
    .pipe(
      map((data: any) => {
        if(data.status !== 1 || (data.status == 1 && !data.data)){
          return null;
        }else{
          return data;
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getAllCompatible(filter: any, realtimeFlag: boolean, fileType: string = null): Observable<any>  { //listing
    return this.http.post(`${environment.apiUrl}/report/dn-revenue/graph-compatible?realtime=${realtimeFlag}&fileType=${fileType}`, filter)
    .pipe(
      map((data: any) => {
        if(data.status !== 1 || (data.status == 1 && !data.data)){
          return null;
        }else{
          return data;
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }


  export(filter: any, realtimeFlag: boolean): Observable<any> { //export
    return this.http.post(`${environment.apiUrl}/report/dn-revenue/export?realtime=${realtimeFlag}`, filter);
  }
}
